import {Dispatch, SetStateAction} from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {ButtonVariant} from "react-bootstrap/types";

export type OnClickConfirmEvent = () => void

interface ConfirmationDialogProps {
    title : string
    bodyText : string
    confirmButtonTitle : string
    onClickConfirmEvent: OnClickConfirmEvent
    showConfirm : boolean
    setShowConfirm : Dispatch<SetStateAction<boolean>>
    buttonVariant? : ButtonVariant
}

export const ConfirmDialog = ({title, bodyText, confirmButtonTitle, onClickConfirmEvent, showConfirm, setShowConfirm, buttonVariant = "danger"} : ConfirmationDialogProps ) =>
{
    return (
        <Modal show={showConfirm} onHide={() => setShowConfirm(false)} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{bodyText}</Modal.Body>
            <Modal.Footer>
                <Button variant={buttonVariant} onClick={onClickConfirmEvent}>
                    {confirmButtonTitle}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
